import i18n from 'i18next'; /* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useState, useRef, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Drawer,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Avatar } from
  '@material-ui/core';
import SearchIcon from '../../icons/Search';
import XIcon from '../../icons/X';
import Scrollbar from './Scrollbar';
// import wait from '../../utils/wait';
import userService from '../../services/userService';
import { useNavigate } from 'react-router';
import helpers from '../../utils/helpers';
import { RenderHelperText } from '../../components/common/account/AccountSectorsV2';
import { Autocomplete } from '@material-ui/lab';
import { Favorite } from '@material-ui/icons';
import useAuth from '../../hooks/useAuth';

// const results = [
//   {
//     description: 'Algolia broadly consists of two parts: search implementation and search analytics. We provide tools that make it easy for your developers...',
//     title: 'What does Algolia do?'
//   },
//   {
//     description: 'To be clear, search doesn’t know the direction that your business should take. However, it can help you gather information on what your customers want...',
//     title: 'Search as a feedback loop'
//   },
//   {
//     description: 'Algolia provides your users with a fast and rich search experience. Your Algolia search interface can contain a search bar, filters, infinite scrolling...',
//     title: 'What can Algolia do for my users?'
//   }
// ];

const ContentSearch = () => {
  const [value, setValue] = useState('');
  const [selectedSector, setSelectedSector] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [results, setResults] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [radioValue, setRadioValue] = useState('sector');
  const navigate = useNavigate();
  const { contentSearchOpen, setContentSearchOpen } = useAuth();

  let intervalId = useRef(null);

  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
    setValue('');
    setShowResults(false);
    // alert(event.target.value);
  };

  const handleOpen = () => {
    setContentSearchOpen(true);
  };

  const handleClose = () => {
    setContentSearchOpen(false);
  };

  const search = async () => {
    if (radioValue === 'company') {
      setShowResults(false);
      setIsLoading(true);
      // Do search here
      // await wait(1500);
      userService.searchCompany({ companyName: value, searchType: radioValue, searchText: value, sector: null })
        .then((response) => {
          if (response) {
            setResults(response);
            setIsLoading(false);
            setShowResults(true);
          }
        });
    }

    if (radioValue === 'bidrequest') {
      navigate(`/deals/${value}`);
      setValue('');
    }

    if (radioValue === 'sector') {
      setShowResults(false);
      setIsLoading(true);
      // Do search here
      // await wait(1500);
      const sector = selectedSector.map((s) => s.id);
      userService.searchCompany({ companyName: '', searchType: radioValue, searchText: '', sector })
        .then((response) => {
          if (response) {
            setResults(response);
            setIsLoading(false);
            setShowResults(true);
          }
        });
    }

    if (radioValue === 'keyword') {
      setShowResults(false);
      setIsLoading(true);
      userService.searchCompany({ companyName: '', searchType: radioValue, searchText: value, sector: [] })
        .then((response) => {
          if (response) {
            setResults(response);
            setIsLoading(false);
            setShowResults(true);
          }
        });
    }
  };

  const handleClick = () => {
    search();
  };

  const handleKeyUp = (event) => {
    if (event.code === 'Enter') {
      search();
    }
  };

  const getSectors = async () => {
    const sec = await helpers.getSectors();
    setSectors(sec);
  };

  useEffect(() => {
    if (radioValue === 'company' || radioValue === 'keyword') {
      if (value.length > 2) {
        if (intervalId) {
          clearTimeout(intervalId);
        }
        intervalId = setTimeout(() => {
          search();
        }, 200);
      }
    }
  }, [value]);

  useEffect(() => {
    if (!selectedSector || selectedSector?.length === 0) {
      return;
    }

    search();
  }, [selectedSector]);

  useEffect(() => {
    if (!contentSearchOpen) {
      setValue('');
      setResults([]);
      setShowResults(false);
      getSectors();
    }
  }, [contentSearchOpen]);

  useEffect(() => {
    setValue('');
  }, []);

  // function searchUrlCreator(resultId) {
  //   let result;
  //   if (radioValue === 'bidrequest') {
  //     result = `/profile/${resultId}`;
  //   } else if (radioValue === 'bidresponse') {
  //     result = `/profile/${resultId}`;
  //   } else if (radioValue === 'company') {
  //     result = `/profile/${resultId}`;
  //   }
  //   return result;
  // }

  return (
    <>
      <TextField
        InputProps={{
          startAdornment: <SearchIcon
            htmlColor="#545454"
            sx={{ mr: 2 }}
          />,

          disableUnderline: true
        }}
        onClick={handleOpen}
        label=""
        placeholder={i18n.t('ContentSearch.firma_i_hale_tedarik\xE7i_ara')}
        fullWidth
        sx={{
          input: {
            '&::placeholder': {
              opacity: 1,
              color: '#545454'
            }
          },
          p: 1,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: '16px',
          pr: 5,
          backgroundColor: '#fff',
          maxWidth: 400
        }}
        color="secondary"
        variant="standard"
        value={value}
      />

      <Drawer
        anchor="top"
        ModalProps={{ BackdropProps: { invisible: true } }}
        onClose={handleClose}
        open={contentSearchOpen}
        PaperProps={{
          sx: { width: '100%' }
        }}
        variant="temporary"
      >

        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >

            <IconButton onClick={handleClose}>
              <XIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ p: 3 }}>
          <Container maxWidth="md">
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex'
              }}
            >

              {
              radioValue && radioValue === 'sector'
                ? (
                  <Autocomplete
                    options={sectors}
                    fullWidth
                    getOptionLabel={(option) => option.name}
                    value={selectedSector}
                    onChange={(e, newVal) => {
                      setSelectedSector(newVal);
                    }}
                    isOptionEqualToValue={(option, val) => option.id === val?.id}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="sector"
                        label={i18n.t('ContentSearch.faaliyet_alan\u0131')}
                        fullWidth
                        variant="outlined"
                        helperText={<RenderHelperText />}
                        autoFocus
                      />
                    )}
                    multiple
                // filterOptions={(options, params) => {
                //   const filtered = filter(options, params);
                //   return filtered;
                // }}
                    renderOption={(props, option, { inputValue }) => {
                      const matches = match(option.name, inputValue, { insideWords: true });
                      const parts = parse(option.name, matches);

                      return (
                        <li {...props}>
                          <div>
                            {parts.map((part, index) => (
                              <span
                                key={index}
                                style={{
                                  fontWeight: part.highlight ? 700 : 400
                                }}
                              >

                                {part.text}
                              </span>
                            ))}
                          </div>
                        </li>
                      );
                    }}
                  />
                )

              // <TextField
              //   select
              //   name="sector"
              //   label="Faaliyet Alanı"
              //   // sx={{ maxWidth: 150 }}
              //   fullWidth
              //   variant="outlined"
              //   // SelectProps={{
              //   //   disableUnderline: true,
              //   // }}
              //   value={selectedSector || ''}
              //   onChange={(e) => {
              //     setSelectedSector(e.target.value);
              //   }}
              //   helperText={<RenderHelperText />}
              // >
              //   {
              //     sectors.map((sector) => (
              //       <MenuItem
              //         key={sector.id}
              //         value={sector.id}
              //       >
              //         {sector.name}
              //       </MenuItem>
              //     ))
              //   }
              // </TextField>
                : (
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment:
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>

                      // disableUnderline: true,
                    }}
                    onChange={(event) => setValue(event.target.value)}
                    onKeyUp={handleKeyUp}
                    placeholder={radioValue === 'company' ? 'Firma adını yazınız...' : radioValue === 'keyword' ? 'Ürün veya hizmet giriniz...' : 'İhale no giriniz...'}
                    value={value}
                    label={radioValue === 'company' ? 'Firma' : radioValue === 'keyword' ? 'Ürün/Hizmet' : 'İhale'}
                    variant="outlined"
                    autoFocus
                  />
                )
}

              <Button
                color="primary"
                onClick={handleClick}
                size="large"
                sx={{ ml: 2 }}
                variant="contained"
              >
                {i18n.t('ContentSearch.ara')}

              </Button>
            </Box>
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex'
              }}
            >

              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radioValue}
                  onChange={handleRadioChange}
                >

                  {/* <FormControlLabel
                     value="bidresponse"
                     control={<Radio size="small" />}
                     label="Teklif ara"
                    /> */}
                  <FormControlLabel
                    value="sector"
                    control={<Radio size="small" />}
                    label={i18n.t('ContentSearch.faaliyet_alan\u0131na_g\xF6re_ara')}
                  />

                  <FormControlLabel
                    value="company"
                    control={<Radio size="small" />}
                    label={i18n.t('ContentSearch.tedarik\xE7i_firma_ara')}
                  />

                  <FormControlLabel
                    value="bidrequest"
                    control={<Radio size="small" />}
                    label={i18n.t('ContentSearch.i_hale_ara')}
                  />

                  <FormControlLabel
                    value="keyword"
                    control={<Radio size="small" />}
                    label={i18n.t('ContentSearch.\xFCr\xFCn_ve_hizmete_g\xF6re_tedarik\xE7i_ara')}
                  />

                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ mt: 3 }}>
              <Scrollbar options={{ suppressScrollX: true }}>
                {isLoading

                  ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >

                      <CircularProgress />
                    </Box>
                  )

                  : (
                    <>
                      {showResults
                  && results.map((result) => (
                    <Box
                      key={result.userToken}
                      sx={{
                        mb: 2,
                        display: 'flex',
                        flexFlow: 'row nowrap',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 0.3
                      }}
                    >

                      <Link
                        color="textPrimary"
                        component={RouterLink}
                        to={`/profile/${result.resultId}`}
                        variant="h5"
                        onClick={handleClose}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}
                      >

                        <Avatar
                          src={`${process.env.REACT_APP_BASE_URL_PURE}${result?.profilePhoto ?? ''}`}
                          sx={{
                            height: 32,
                            width: 32
                          }}
                        />

                        <Typography
                          color="textPrimary"
                          variant="body2"
                        >

                          {result.resultText}
                        </Typography>
                      </Link>

                      {
                    result?.isFavorite
                    && (
                    <IconButton size="small">
                      <Favorite
                        color="primary"
                        fontSize="small"
                        titleAccess="Favori firma"
                      />

                    </IconButton>
                    )

                    }
                    </Box>
                  ))}
                      {showResults && results.length === 0
                  && (
                  <Box
                    sx={{ mb: 2 }}
                  >

                    <Typography
                      color="textSecondary"
                      variant="body2"
                    >
                      {i18n.t('ContentSearch.sonu\xE7_bulunamad\u0131')}

                    </Typography>
                  </Box>
                  )}
                    </>
                  )}
              </Scrollbar>
            </Box>
          </Container>
        </Box>
      </Drawer>
    </>
  );
};

export default ContentSearch;
